export default function shareButton({ title, url }) {
    return {
        title,
        url,
        open: false,
        copied: false,

        async share() {
            // 📱 мобильные — нативный share
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: this.title,
                        url: this.url,
                    });
                } catch (e) {}
                return;
            }

            // 💻 десктоп — показываем всплывашку
            this.open = true;
            this.copied = false;
        },

        async copy() {
            try {
                await navigator.clipboard.writeText(this.url);
                this.copied = true;

                // автозакрытие через 1.2 сек
                setTimeout(() => {
                    this.open = false;
                }, 1200);
            } catch (e) {
                alert('Не удалось скопировать ссылку');
            }
        }
    };
}
